import { type Guard } from '@capsicum/common';
import { useRouter } from '@capsicum/common-web';
import { useV2MigrationGuardStatus } from '@capsicum/features/nc-wallet/shared';
import { useParams } from 'next/navigation';

import { useV2MigrationStatus } from './useV2MigrationStatus';

export const useV2MigrationGuard: Guard = () => {
	const { replace } = useRouter();
	const { currencyId } = useParams<{ currencyId: string }>();
	const { isLoading: isV2MigrationStatusLoading, isMigrating } = useV2MigrationStatus();

	const status = useV2MigrationGuardStatus({
		currencyId,
		isMigrating,
		isV2MigrationStatusLoading
	});

	return {
		onDenied: () => replace('/home'),
		status
	};
};
